import { z } from "zod";

export const postUpdateCanadianPayrollBusinessEntitySchema = z.object({
  accessToken: z.string(),
  name: z.string().min(1),
  legal_name: z.string().optional(),
  business_number: z.string().length(15).optional(),
  legal_registration_number: z.string().optional(),
  address_line_1: z.string().max(30).optional(),
  address_line_2: z.string().max(30).optional(),
  city: z.string().max(28).optional(),
  province_code: z.string().optional(),
  country_code: z.string().default("CA"),
  postal_code: z.string().max(10).optional(),
  contact_name: z.string().max(255).optional(),
  contact_email: z.string().email().optional(),
  contact_area_code: z.string().optional(),
  contact_phone_number: z.string().optional(),
  contact_extension: z.string().max(5).optional(),
  pay_day_movement_setting: z
    .enum(["inherit", "previous_business_day", "next_business_day"])
    .optional(),
  vacation_pay_formula_setting: z
    .enum(["period_start", "period_end", "pay_date"])
    .optional(),
  remitter_type: z
    .enum([
      "quarterly",
      "regular",
      "accelerated_threshold_1",
      "accelerated_threshold_2",
    ])
    .optional(),
  preferred_locale: z.enum(["en", "fr"]).optional(),
});

export type TPostUpdateCanadianPayrollBusinessEntityRequest = z.infer<
  typeof postUpdateCanadianPayrollBusinessEntitySchema
>;

export type TPostUpdateCanadianPayrollBusinessEntityResponse = {
  success: boolean;
  business_entity_id: string;
};
